import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// global initialization steps
(() => {
  window.toEnglishDigits = function (string) {
      return string.replace(/[۰-۹]/g, function (chr) {
          var persian = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
          return persian.indexOf(chr);
      });
  };
})()

ReactDOM.render(<App />, document.getElementById('groot'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
